<ng-container *ngTemplateOutlet="renderNodes; context: { nodes: template?.rows }"></ng-container>

<ng-template #renderNodes let-nodes="nodes">
    @for (node of nodes; track node) {
        @if (node.type === 'row') {
            <div class="row {{ node.classes ?? '' }}">
                <ng-container *ngTemplateOutlet="renderNodes; context: { nodes: node.children }"></ng-container>
            </div>
        } @else if (node.type === 'div') {
            <div [class]="node.classes">
                <ng-container *ngTemplateOutlet="renderNodes; context: { nodes: node.children }"></ng-container>
            </div>
        } @else {
            @if (fieldMap.get(node); as field) {
                <app-field-input [class]="node.classes" [key]="node.fieldKey" [field]="field" [formData]="formData" />
            }
        }
    }
</ng-template>
